import { render, staticRenderFns } from "./TripDetailFooter.vue?vue&type=template&id=6fe5f2c0&"
import script from "./TripDetailFooter.vue?vue&type=script&lang=ts&"
export * from "./TripDetailFooter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports